<template>
  <div>
    <el-card shadow="never" class="invoice_card">
      <div slot="header" class="clearfix">
        <el-button type="text" class="backBtn" @click="changeBack">返回</el-button>
        <span class="font18">预存划拨</span>
      </div>
      <div class="team_box">
        <el-input
          style="width: 50%"
          placeholder="请输入划拨人团体名称、划拨人姓名、手机号"
          v-model="querySearch.condition"
          prefix-icon="el-icon-search"
        >
          <div slot="append">
            <div style="cursor: pointer;width: 100%" @click="getList()">搜索</div>
          </div>
        </el-input>
        <el-table
          :data="teamData"
          border
          :header-cell-style="{background:'#F5F5F5'}"
          style="width: 100%;font-size: 14px;margin-top: 20px"
        >
          <el-table-column label="团队名称" prop="teamName"></el-table-column>
          <el-table-column label="团长" prop="teamHeadName"></el-table-column>
          <el-table-column label="手机号" prop="teamHeadPhone"></el-table-column>
          <el-table-column label="团体成员数" prop="personnelNum"></el-table-column>
          <el-table-column label="所属单位/高校" prop="affiliatedUnit"></el-table-column>
          <el-table-column label="划拨金额" prop="transferMoney" width="120">
            <template slot-scope="scope">
              <el-input-number
                style="width: 100%"
                v-model="scope.row.transferMoney"
                :precision="2"
                :controls="false"
                :min="0"
                size="mini"
                :max="userInfo.depositAdvanceTeam"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" :disabled="!scope.row.transferMoney" @click="confirmHandle(scope.row)">确认划拨</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>
<script>
import { getClient } from "@/plugins/auth";
import { teamList, prestoreTransfer } from "@/api/request";
export default {
  data() {
    return {
      teamData: [],
      userInfo: JSON.parse(getClient()),
      querySearch: {
        pageNum: 1,
        pageSize: 100,
        condition: ""
      }
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      if (this.querySearch.condition != "") {
        this.querySearch.teamId = this.userInfo.teamId;
        teamList(this.querySearch).then(res => {
          this.teamData = res.rows.length > 0 ? res.rows.map(i=> {
              return {...i,transferMoney: 0}
          }): [];
          this.teamData.map(item => {
            item.teamHeadPhone = this.encryptionPhoneNumber(item.teamHeadPhone)
          })
        });
      }
    },
    confirmHandle(row) {
      let userInfo = this.userInfo;
      this.$confirm(
        "是否确认从团队预存余额划拨¥" +
          row.transferMoney +
          "至“" +
          row.teamName +
          "”团队预存？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false
        }
      )
        .then(function() {
          return prestoreTransfer({
            applyTeamId: userInfo.teamId,
            receiveTeamId: row.teamId,
            transferMoney: row.transferMoney
          });
        })
        .then(() => {
          this.getList();
          this.$store.dispatch("GetInfo").then(() => {}).catch(err => {});
          this.$message.success("操作成功");
        });
    },
    changeBack() {
      this.$emit("back");
    }
  }
};
</script>